import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const TRANSACTION_DETAIL = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  CHECK_ACTIVITY_REQUEST: null,
  CHECK_ACTIVITY_SUCCESS: null,
  HANDLE_REQUEST: null,
  HANDLE_SUCCESS: null,
}, 'TRANSACTION_DETAIL')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  var endpoint = 'cgs/personal/bill/detail'
  if (data.orderNo) {
    endpoint = 'cgs/personal/bill/tradeDetail'
  }
  if (data.feeBillId) {
    endpoint = 'cgs/feebill/query/v1/get-detail'
  }
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: endpoint,
        requestAction: TRANSACTION_DETAIL.INIT_REQUEST,
        successAction: TRANSACTION_DETAIL.INIT_SUCCESS,
        success: function(result) {
          dispatch(checkActivity({ voucherNo: result.tradeVoucherNo }))
        },
      })
    )
  }
}

export function checkActivity(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/marketing/redpkg/list',
        requestAction: TRANSACTION_DETAIL.CHECK_ACTIVITY_REQUEST,
        successAction: TRANSACTION_DETAIL.CHECK_ACTIVITY_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function getLLEInvoice(data) {
  return (dispatch) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/personal/bill/detail/file',
        requestAction: TRANSACTION_DETAIL.HANDLE_REQUEST,
        successAction: TRANSACTION_DETAIL.HANDLE_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [TRANSACTION_DETAIL.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [TRANSACTION_DETAIL.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
  [TRANSACTION_DETAIL.CHECK_ACTIVITY_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [TRANSACTION_DETAIL.CHECK_ACTIVITY_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
  [TRANSACTION_DETAIL.HANDLE_REQUEST]: (state, action) => state,
  [TRANSACTION_DETAIL.HANDLE_SUCCESS]: (state, action) => state,
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'transactionDetail',
    reducerMap: {
      transactionDetailState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
